export function apiConsolelog (...args) {
  // console.log(...args)
}

export function requestConsolelog (...args) {
  // console.log(...args)
}
